var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12C22.5 16.9914 18.843 21.1285 14.0625 21.8785V14.8906H16.3926L16.8359 12H14.0625V10.1242C14.0625 9.3332 14.45 8.5625 15.6922 8.5625H16.9531V6.10156C16.9531 6.10156 15.8086 5.90625 14.7145 5.90625C12.4305 5.90625 10.9375 7.29063 10.9375 9.79688V12H8.39844V14.8906H10.9375V21.8785C6.15703 21.1285 2.5 16.9914 2.5 12C2.5 6.47734 6.97734 2 12.5 2C18.0227 2 22.5 6.47734 22.5 12Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3926 14.8906L16.8359 12H14.0625V10.1242C14.0625 9.33336 14.4499 8.5625 15.6921 8.5625H16.9531V6.10156C16.9531 6.10156 15.8088 5.90625 14.7146 5.90625C12.4304 5.90625 10.9375 7.29063 10.9375 9.79688V12H8.39844V14.8906H10.9375V21.8785C11.4466 21.9584 11.9684 22 12.5 22C13.0316 22 13.5534 21.9584 14.0625 21.8785V14.8906H16.3926Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.f02a112ecfbfbd67d71f73d65c703896.svg";
export { ForwardRef as ReactComponent };